
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-twitter",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","stroke":"currentColor","fill":"transparent","class":"icon i-twitter"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.83 4.94a10.81 10.81 0 01-2.53 2.61v.65A14.26 14.26 0 018 22.56 14.31 14.31 0 01.21 20.3a12.16 12.16 0 001.22.06 10.08 10.08 0 006.26-2.16A5.06 5.06 0 013 14.7a6.12 6.12 0 001 .08 5.39 5.39 0 001.33-.17 5 5 0 01-4-4.95v-.07a5 5 0 002.28.64 5 5 0 01-1.68-6.75 14.28 14.28 0 0010.4 5.28 6.23 6.23 0 01-.12-1.15 5 5 0 018.73-3.45 10.21 10.21 0 003.21-1.22 5.11 5.11 0 01-2.22 2.78 10.11 10.11 0 002.9-.78z"}})])
          )
        }
      }
    